export {default} from '../../core/components/About';